module.exports = __webpack_public_path__ + "img/liuchengzhongxin.46b54417.png";